import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-94" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-95" data-mp="9tl7ct61zbs7">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-line bg-panel p-8 shadow-card sm:p-12" data-id="element-96" data-mp="et6735t1ro5z">
          <span className="inline-flex rounded-full bg-accentSoft p-4 text-accent" data-id="element-97" data-mp="skcc1hf3ie09">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-98" data-mp="xjxj6f4f5so2" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-99" data-mp="xlrzth8nqymc">
            Garantía total de 7 días
          </h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-100" data-mp="17hbtdwzr1l7x">
            Abre los 9 tomos. Revisa los 5 bonos. Úsalos en tu clase más difícil esta semana. Si sientes que tus alumnos
            no respondieron mejor, o que el material no te ahorró horas de trabajo:
          </p>
          <p className="mt-6 rounded-lg bg-accentSoft px-5 py-4 text-lg font-extrabold text-onDark" data-id="element-101" data-mp="1vthgefv1pcnd">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios. Sin complicaciones.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-102" data-mp="2oiofbfyew495">
            Porque si el material no te da el valor que prometemos, no queremos quedarnos con tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}